<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import flashMessage from "../../components/flashMessahe";
import ErrorMessage from "../../components/error-message";
import VueSweetalert2 from "vue-sweetalert2";
import {
  required,
  email,
  minLength,
  sameAs,
  maxLength,
  minValue,
  maxValue,
  numeric,
  url,
  alphaNum,
} from "vuelidate/lib/validators";

export default {
  components: {
      ErrorMessage,
    Layout,
    PageHeader,
    flashMessage,
  },
  data() {
    return {
      errorMessage: "",
      title: "Hotel Routing Update",
      items: [
        {
          text: "Hotel Routing",
          href: "/",
        },
        {
          text: "Update",
          active: true,
        },
      ],
      vendors: [],
      airlines: [],
      uuid: "",
      status: "not_accepted",
      checkCustom: "not_accepted",
      checked: true,
      errors: null,
        visible:false,
        message:"",
        lineError:true,
      form: {
          hotel_name:"",
          api_vendor_id:"",
          destination:"",
          country_code:"",
          is_allowed:"",
      },
      submitform: false,
      submitted: false,
    };
  },
  validations: {
    form: {
        is_allowed: {
            required,
        },
    },
  },

  created() {
    this.uuid = this.$route.params.uuid;
  },
  mounted() {
    this.routeDetail();
    this.getVendorList();
    // this.getAirlineList();
  },
  methods: {
      onClose(){
          this.visible=false;
      },
    // async getAirlineList() {
    //   try {
    //     axios
    //       .get("/api/airline/list", {
    //         params: {
    //           accessToken: localStorage.getItem("access_tocken"),
    //         },
    //       })
    //       .then((response) => {
    //         if (response.data.status) {
    //           this.airlines = response.data.data;
    //         } else {
    //           var str = response.data.message;
    //           var jsonParse = JSON.parse(str);
    //           this.errorCheck(jsonParse);
    //         }
    //       })
    //       .catch((error) => {
    //         console.log(error.message);
    //       });
    //   } catch (err) {
    //     console.log(err);
    //   }
    // },
    async getVendorList() {
      try {
        axios
          .get("/api/vendor/list", {
            params: {
              accessToken: localStorage.getItem("access_tocken"),
            },
          })
          .then((response) => {
            if (response.data.status) {
              this.vendors = response.data.data;
            } else {
              var str = response.data.message;
              var jsonParse = JSON.parse(str);
              this.errorCheck(jsonParse);
            }
          })
          .catch((error) => {
            console.log(error.message);
          });
      } catch (err) {
        console.log(err);
      }
    },
    async routeDetail() {
      try {
        axios
          .post("/api/hotel/route_detail/" + this.uuid, {
            accessToken: localStorage.getItem("access_tocken"),
          })
          .then((response) => {
            if (response.data.status) {
              var data = response.data.data;
                this.form.hotel_name=data.hotel_name,
                    this.form.api_vendor_id=data.api_vendor_id,
                    this.form.is_allowed=data.is_allowed,
                    this.form.destination=data.destination,
                    this.form.country_code=data.country_code
            } else {
              var str = response.data.message;
              var jsonParse = JSON.parse(str);
              this.errorCheck(jsonParse);
            }
          })
          .catch((error) => {
            console.log(error.message);
          });
      } catch (err) {
        console.log(err);
      }
    },
    formSubmit(event) {
      this.submitted = true;
      this.$v.$touch();
      axios
        .put("/api/hotel/route_update", {
          uuid: this.uuid,
            hotel_name:this.form.hotel_name,
            api_vendor_id: this.form.api_vendor_id,
            is_allowed: this.form.is_allowed,
            destination: this.form.destination,
            country_code: this.form.country_code,
            created_by: localStorage.getItem("id"),
            updated_by: localStorage.getItem("id"),
            accessToken: localStorage.getItem("access_tocken"),
        })
        .then((response) => {
          if (response.data.status) {
            this.$refs.hotelRoutingUpdateForm.reset();
            this.$swal("Good job!", "Hotel Route Updated", "success");
            this.$router.push({ name: "hotel_route_list" });
          } else {
            var str = response.data.message;
            var jsonParse = JSON.parse(str);
            this.errorCheck(jsonParse);
          }
        })
        .catch((error) => {
          if (error.response != undefined) {
            this.errors = error.response.data.errors;
          }
        });
    },
    errorCheck(obj) {
        if(obj.statusCode == 403){
            this.visible=true;
            this.lineError=false;
            this.message="Access Permission Denied";
            this.errors = obj.message;
        }else if (obj.error) {
        this.errors = obj.message;
      } else if (obj.message == "Token has expired") {
          this.$swal.fire({
              title: 'LogOut!',
              text: 'Token Has Expired',
              icon: 'error',
              toast:'true',
              position: 'top-end',
          });
        this.$router.push({ name: "logout" });
      } else if (
        obj.message !== "Token has expired" &&
        obj.message !== "The given data was invalid."
      ) {
        this.errors = obj.message;
      } else if (obj.message == "The given data was invalid.") {
        this.errors = obj.errors;
      } else {
        this.flashMessage.show({
          time: 5000,
          status: "error",
          title: "Error",
          message: "Problem in data save",
        });
      }
    },
    resetForm(event) {
      console.log("Reseting the form");
      event.target.reset();
    },
  },
};
</script>


<template>
    <Layout>
        <flashMessage/>
        <PageHeader :title="title" :items="items" />
        <ErrorMessage :visible="visible" :errors="errors" v-on:close="onClose" :message="message"/>
        <div class="row">
            <div class="col-lg-12 col-sm-12">
                <div class="card">
                    <div class="card-body">
                        <div v-if="errors" class="font-bold mb-4 ">
                            <div v-for="(v, k) in errors" :key="k">
                                <p v-for="error in v" :key="error" class="text-sm">
                                    {{ error }}
                                </p>
                            </div>
                        </div>
                        <b-form class="needs-validation" ref="hotelRoutingUpdateForm" @submit.prevent="formSubmit">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="is_allowed">Allowed</label>
                                        <select
                                            id="is_allowed"
                                            name="is_allowed"
                                            v-model="form.is_allowed"
                                            class="form-control"
                                            :class="{ 'is-invalid': submitted && $v.form.is_allowed.$error }">
                                            <option value="" disabled style="display:none" selected>Select Allowed</option>
                                            <option value='1'>Yes</option>
                                            <option value='0'>No</option>
                                        </select>
                                        <div
                                            v-if="submitted && $v.form.is_allowed.$error"
                                            class="invalid-feedback"
                                        >
                                            <span v-if="!$v.form.is_allowed.required">This value is required.</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="api_vendor_id ">API Vendor ID</label>
                                        <select
                                            id="api_vendor_id "
                                            name="api_vendor_id "
                                            v-model="form.api_vendor_id "
                                            class="form-control"
                                            :class="{ 'is-invalid': submitted && $v.form.api_vendor_id.$error }">
                                            <option value="" disabled style="display:none" selected>Select Api Vendor Id</option>
                                            <option v-for="(vendor, index) in vendors" :value="vendor.id" v-if="vendor.is_active==1"
                                                    v-bind:key="index">{{ vendor.api_provider }}
                                            </option>
                                        </select>
                                        <div
                                            v-if="submitted && $v.form.api_vendor_id.$error"
                                            class="invalid-feedback"
                                        >
                                            <span v-if="!$v.form.api_vendor_id.required">This value is required.</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label class="required" for="hotel_name">Hotel Name</label>
                                        <input
                                            id="hotel_name"
                                            v-model="form.hotel_name"
                                            name="hotel_name"
                                            type="text"
                                            class="form-control"
                                            placeholder="Type Hotel Name "
                                            value
                                            :class="{ 'is-invalid': submitted && $v.form.hotel_name.$error }"
                                        />
                                        <div
                                            v-if="submitted && $v.form.hotel_name.$error"
                                            class="invalid-feedback"
                                        >
                                            <span v-if="!$v.form.hotel_name.required">This value is required.</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="destination">Destination</label>
                                        <input
                                            id="destination"
                                            v-model="form.destination"
                                            name="destination"
                                            type="text"
                                            class="form-control"
                                            placeholder="Type Destination "
                                            value
                                            :class="{ 'is-invalid': submitted && $v.form.destination.$error }"
                                        />
                                        <div
                                            v-if="submitted && $v.form.destination.$error"
                                            class="invalid-feedback"
                                        >
                                            <span v-if="!$v.form.destination.required">This value is required.</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="country_code">Country Code</label>
                                        <input
                                            id="country_code"
                                            v-model="form.country_code"
                                            name="country_code"
                                            type="text"
                                            class="form-control"
                                            placeholder="Type country code"
                                            value
                                            :class="{ 'is-invalid': submitted && $v.form.country_code.$error }"
                                        />
                                        <div
                                            v-if="submitted && $v.form.country_code.$error"
                                            class="invalid-feedback"
                                        >
                                            <span v-if="!$v.form.country_code.required">This value is required.</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <button class="btn btn-primary" type="submit">Submit</button>
                        </b-form>
                    </div>
                </div>
                <!-- end card -->
            </div>
            <!-- end col -->
        </div>
        <!-- end row -->
    </Layout>
</template>
